module.exports = __webpack_public_path__ + "img/document.348495dd.svg";